import React, { useState } from "react";
import { Row, Card, CardBody, Modal, ModalHeader, ModalBody, Col } from "reactstrap";
import FullCalendar from "@fullcalendar/react";
import dayGridPlugin from "@fullcalendar/daygrid";
import interactionPlugin from "@fullcalendar/interaction";
import BootstrapTheme from "@fullcalendar/bootstrap";
import "@fullcalendar/bootstrap/main.css";
import { AvForm, AvField } from "availity-reactstrap-validation";
function AdminCalendar() {
  const eventColor = "#d43e01";
  const [modal, setModal] = useState(false);
  const [newEvent, setNewEvent] = useState(null);

  const addEvent = () => setModal(!modal);

  const handleCreateEvent = (event, errors, values) => {
    if (errors.length === 0) {
      setNewEvent(values);
      setModal(false);
    
    }
  };

  const indianFestivals = [
    // 2023
    { title: "Makar Sankranti", start: "2023-01-14", end: "2023-01-14" },
    { title: "Pongal", start: "2023-01-14", end: "2023-01-14" },
    { title: "Republic Day", start: "2023-01-26", end: "2023-01-26" },
    { title: "Holi", start: "2023-03-02", end: "2023-03-02" },
    { title: "Eid al-Fitr", start: "2023-05-01", end: "2023-05-01" },
    { title: "Raksha Bandhan", start: "2023-08-22", end: "2023-08-22" },
    { title: "Independence Day", start: "2023-08-15", end: "2023-08-15" },
    { title: "Ganesh Chaturthi", start: "2023-09-13", end: "2023-09-13" },
    { title: "Dussehra", start: "2023-10-24", end: "2023-10-24" },
    { title: "Diwali", start: "2023-11-12", end: "2023-11-12" },
    { title: "Christmas", start: "2023-12-25", end: "2023-12-25" },

    // 2024
    { title: "Makar Sankranti", start: "2024-01-14", end: "2024-01-14" },
    { title: "Pongal", start: "2024-01-14", end: "2024-01-14" },
    { title: "Republic Day", start: "2024-01-26", end: "2024-01-26" },
    { title: "Holi", start: "2024-03-21", end: "2024-03-21" },
    { title: "Eid al-Fitr", start: "2024-04-20", end: "2024-04-20" },
    { title: "Raksha Bandhan", start: "2024-08-11", end: "2024-08-11" },
    { title: "Independence Day", start: "2024-08-15", end: "2024-08-15" },
    { title: "Ganesh Chaturthi", start: "2024-09-01", end: "2024-09-01" },
    { title: "Dussehra", start: "2024-10-14", end: "2024-10-14" },
    { title: "Diwali", start: "2024-11-02", end: "2024-11-02" },
    { title: "Christmas", start: "2024-12-25", end: "2024-12-25" },
  ];

  return (
    <div>
    <Card>
      <CardBody>
        <Row style={{ height: "480px" }}>
        <FullCalendar
              plugins={[BootstrapTheme, dayGridPlugin, interactionPlugin]}
              slotDuration={"00:15:00"}
              handleWindowResize={true}
              themeSystem="bootstrap"
              editable={true}
              droppable={true}
              selectable={true}
              eventColor={eventColor}
              events={indianFestivals}
              dateClick={addEvent} 
            />
        </Row>
      </CardBody>
    </Card>
    <Modal isOpen={modal} toggle={addEvent}>
        <ModalHeader toggle={addEvent}>Create Event</ModalHeader>
        <ModalBody>
          <AvForm onValidSubmit={handleCreateEvent}>
            <AvField name="title" label="Title" type="text" required />
            <AvField name="start" label="Start" type="date" required />
            <AvField name="end" label="End" type="date" required />
            <div className="text-center mt-4">
              <button type="submit" className="btn btn-primary">Create</button>
            </div>
          </AvForm>
        </ModalBody>
      </Modal>
  </div>
  );
}

export default AdminCalendar;
